import { useState } from "react";
import { CheckSquare, Square } from "lucide-react";

export const SCORE_ITEMS = [
  ["video_verification", "Customer video verification with recorded consent", 35, "AEGIS verify"],
  ["delivery_signature", "Delivery signature / delivery photo", 40, "Strongest"],
  ["tracking", "Tracking confirmation", 30], ["order_email", "Order confirmation email", 25], ["refund_policy", "Refund policy acceptance", 25],
  ["login", "Customer login after purchase", 20], ["tos", "Terms of Service acceptance", 20], ["usage", "Product usage evidence", 15],
  ["address_match", "Billing / shipping address match", 10], ["positive_comms", "Positive customer communication", 10], ["repeat_customer", "Repeat customer history", 5],
];
export const verdictOf = (s) => (s >= 90 ? ["DEFEND", "text-brand"] : s >= 60 ? ["BORDERLINE · ADD EVIDENCE", "text-amber-300"] : ["WEAK · CONSIDER REFUND", "text-red-400"]);

export const EvidenceScorer = () => {
  const [on, setOn] = useState({});
  const score = SCORE_ITEMS.reduce((a, [k, , p]) => a + (on[k] ? p : 0), 0);
  const [label, tone] = verdictOf(score);
  return (
    <div className="grid lg:grid-cols-[1fr_280px] gap-6" data-testid="manual-scorer">
      <ul className="space-y-2">
        {SCORE_ITEMS.map(([k, l, p, tag]) => (
          <li key={k}>
            <button onClick={() => setOn({ ...on, [k]: !on[k] })} data-testid={`score-item-${k}`}
              className={`w-full flex items-center gap-3 p-3 border text-left transition-colors ${on[k] ? "border-brand/50 bg-brand/[0.05]" : "border-line hover:border-white/25"}`}>
              {on[k] ? <CheckSquare className="w-4 h-4 text-brand" /> : <Square className="w-4 h-4 text-white/30" />}
              <span className="flex-1 text-sm">{l}{tag && <span className="ml-2 font-mono text-[9px] text-accent2">{tag.toUpperCase()}</span>}</span>
              <span className="font-mono text-sm text-brand">+{p}</span>
            </button>
          </li>
        ))}
      </ul>
      <div className="panel p-5 self-start lg:sticky lg:top-24">
        <p className="label-xs">Your evidence score</p>
        <p className="font-mono text-5xl font-extrabold mt-2 text-brand tabular" data-testid="scorer-total">{score}</p>
        <div className="h-1.5 bg-white/5 mt-3 relative"><div className="h-full bg-brand transition-[width] duration-500" style={{ width: `${Math.min(100, (score / 235) * 100)}%` }} /><span className="absolute top-[-4px] h-3 w-px bg-white/60" style={{ left: "38.3%" }} /></div>
        <p className="font-mono text-[10px] text-white/40 mt-1">threshold to defend: 90</p>
        <p className={`font-mono text-xs tracking-wider mt-4 ${tone}`} data-testid="scorer-verdict">{label}</p>
        <button onClick={() => setOn({})} className="mt-4 font-mono text-[10px] text-white/45 hover:text-white" data-testid="scorer-reset">RESET</button>
        <p className="text-[11px] text-white/40 mt-4">Every real dispute page shows this score automatically, from the evidence AEGIS collected.</p>
      </div>
    </div>
  );
};
